import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
const ClassC000111 = () => {
  const [isRecognizing, setIsRecognizing] = useState(false);
  const [log, setLog] = useState("");
  const [recognition, setRecognition] = useState(null);
  const [synth, setSynth] = useState(null);

  useEffect(() => {
    // 初始化語音辨識
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognitionInstance = new SpeechRecognition();
    recognitionInstance.lang = "zh-TW"; // 設定語言為繁體中文
    recognitionInstance.interimResults = false; // 禁用中間結果

    recognitionInstance.onstart = () => {
      setIsRecognizing(true);
      setLog("語音辨識中，請開始說話...");
      console.log("語音辨識中，請開始說話...");
    };

    recognitionInstance.onend = () => {
      setIsRecognizing(false);
      setLog("語音辨識已停止，等待您的指示。");
      console.log("語音辨識已停止，等待您的指示。");
    };

    recognitionInstance.onresult = async (event) => {
      const userText = event.results[0][0].transcript; // 獲取辨識的文字
      setLog(`您說了：${userText}`);
      console.log(`您說了：${userText}`);

      // 呼叫 API 並回應
      const gptResponse = await sendMessage(userText);
      setLog(`AI 回應：${gptResponse}`);
      speakText(gptResponse); // 播放回應語音
    };

    recognitionInstance.onerror = (event) => {
      console.error("語音辨識錯誤：", event.error);
      setLog("語音辨識發生錯誤，請重試。");
    };

    setRecognition(recognitionInstance);

    // 初始化語音合成
    const synthInstance = window.speechSynthesis;
    setSynth(synthInstance);
  }, []);

  const sendMessage = async (input) => {
    const url = "https://chat-ai.tut.edu.tw:11435/api/chat";
    const data = {
      model: "gemma2",
      messages: [
        { role: "system", content: "你好！有什麼我可以協助的呢?" },
        { role: "user", content: input },
      ],
      stream: false,
    };

    try {
      const response = await axios.post(url, data);
      if (response.status === 200) {
        return response.data.message.content;
      } else {
        console.error(`Error: ${response.status}, ${response.data}`);
      }
    } catch (error) {
      console.error(
        `Error: ${error.response ? error.response.status : "Network Error"}, ${
          error.message
        }`
      );
    } finally {
    }
  };

  const speakText = (text) => {
    if (synth) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "zh-TW"; // 設定語言為繁體中文
      // utterance.rate = 1.2; // 語速
      // utterance.pitch = 1.2; // 音調
      synth.speak(utterance);
    }
  };

  return (
    <div>
      <h1>語音助手</h1>
      <button onClick={() => !isRecognizing && recognition.start()}>
        開始辨識
      </button>
      <button onClick={() => isRecognizing && recognition.stop()}>
        停止辨識
      </button>
      <div id="log">{log}</div>
    </div>
  );
};

export default connect((state) => ({ user: state.user }), {})(ClassC000111);
